export const textToKebab = (text: string) =>
  text.trim()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/-$/g, '') // Remove trailing -
    .toLowerCase()

export const pascalToKebab = (pascal: string) =>
  pascal.trim()
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/([A-Z])([A-Z])(?=[a-z])/g, '$1-$2')
    .toLowerCase()

export const statelessFunctionNameToKebab = (statelessFunctionName: string) =>
  textToKebab(statelessFunctionName.split(/(?=[A-Z])/).join(' '))
